import React from "react";
import GenericDraggableTableView from "../../../Features/Table/GenericDraggableTable";
import { useClientApiData } from "./hooks/useClientApiData";
import { useClientApiColumns } from "./hooks/useClientApiColumns";

const ROWS_PER_PAGE = 10;

const ClientApiManagementContent = () => {
  const {
    pagedData,
    total,
    isLoading,
    pageNumber,
    setPageNumber,
    applySearch,
    searchSuggestionsHandler,
  } = useClientApiData();

  const {
    allColumns,
    visibleColumns,
    setVisibleColumns,
    selectedColumnKeys,
    defaultColumnKeys,
    applySelectedColumns,
  } = useClientApiColumns();

  return (
    <GenericDraggableTableView
      title="Client APIs"
      count={total}
      showPrimaryButton={false}
      tableColumns={visibleColumns}
      initialColumns={allColumns}
      selectedColumns={selectedColumnKeys}
      defaultSelectedColumns={defaultColumnKeys}
      applySelectedColumns={applySelectedColumns}
      onColumnOrderChange={(newCols) => setVisibleColumns(newCols)}
      tableData={pagedData}
      isLoading={isLoading}
      pageNumber={pageNumber}
      rowsPerPage={ROWS_PER_PAGE}
      total={total}
      onPageChange={(page) => setPageNumber(page)}
      applySearch={applySearch}
      searchableFields={[{ key: "name", title: "Client API Name" }]}
      searchSuggestionsHandler={searchSuggestionsHandler}
      disableDownloads={true}
      disableFiltersSettings={true}
      emptyMessage="No client APIs found"
    />
  );
};

export default ClientApiManagementContent;
